import { render } from "./BannerPartner.vue?vue&type=template&id=3f8e4768"
import script from "./BannerPartner.vue?vue&type=script&lang=js"
export * from "./BannerPartner.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__